export const allSettled = async (promises = []) => (await Promise.allSettled(promises)).map(result => (result.status === 'fulfilled' ? result.value : null))
